export const getEllipsisTextFormatted = ({ str }: { str: string }) => {
  try {
    if (str.length <= 12) return str;
    return `${str.substr(0, 6)}...${str.slice(-3)}`;
  } catch (e) {
    console.warn(e);
    return str;
  }
};

export const tokenStatusType = {
  PENDING: 'PENDING',
  NO_TOKEN: 'NO_TOKEN',
  INVALID_TOKEN: 'INVALID_TOKEN',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
};

export const getTokenMsg = ({ status }: { status: string }) => {
  switch (status) {
    case tokenStatusType.NO_TOKEN:
      return 'Error: No token present, please follow link from Learning Portal';
    case tokenStatusType.INVALID_TOKEN:
    case tokenStatusType.EXPIRED_TOKEN:
      return 'Error: This link has either expired or invalid, please use the link from Learning Portal again';
    case tokenStatusType.PENDING:
    default:
      return '';
  }
};

export const defaultCertImageURL =
  'https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/skeleton.png';

export const defaultMintDetailsProps = {
  textList: [
    'Authenticity of your certificate is traceable',
    'Access to ... (TBD)',
  ],
  ctaText: 'Mint my certificate',
  ctaOnClick: () => {},
  title: 'How To Build Your Brand Online',
  headerText: 'Collection  #000001',
  headerSecondaryText: '10,000 NFT supply',
};
